import { render, staticRenderFns } from "./UserMailChange.vue?vue&type=template&id=bb5ece1a"
import script from "./UserMailChange.vue?vue&type=script&lang=js"
export * from "./UserMailChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports